import styled, { css } from 'styled-components';
import { Heading5, Text2 } from 'app/shared/ui';

import { color, media, zIndex } from 'app/shared/styles_js/variables';

export const ModalSt = styled.div`
  position: fixed;
  z-index: ${zIndex.slideIn};
  bottom: 21px;
  left: calc((100% - 712px) / 2 - 16px);
  overflow: hidden;
  width: 470px;
  height: 258px;
  color: ${color.white};
  border-radius: 4px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
  transform: ${({ mode }) => {
    switch (mode) {
      case 'bounce':
        return 'translateY(-100px)';
      case 'slide':
        return 'translateY(0)';
      default:
        return 'translateY(470px)';
    }
  }};
  transition: transform 0.8s ease-in-out;

  ${media.lg(css`
    left: calc((100% - 952px) / 2 - 16px);
  `)}
  ${media.xl(css`
    left: calc((100% - 1173px) / 2 - 16px);
  `)}
`;

export const ModalWrapperSt = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px;
  background-color: ${color.brandSecondaryLight};
`;

export const ContentWrapperSt = styled.div`
  display: flex;
  flex-direction: row;
  align-items: initial;
  justify-content: initial;
`;

export const IconCloseSt = styled.i`
  cursor: pointer;
  font-size: ${({ iconSize }) => iconSize}px;
  color: ${({ c }) => c};
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const HeadingSt = styled(Heading5).attrs(() => ({
  fontWeight: 300,
}))`
  color: white;
`;

export const TextSt = styled(Text2).attrs(() => ({
  as: 'p',
}))`
  padding-right: 14px;
  margin-bottom: 5px;
`;

export const BoldTextSt = styled(Text2).attrs(() => ({
  as: 'span',
}))`
  display: block;
  font-weight: bold;
`;

export const ImageSt = styled.img`
  width: 176px;
  max-width: none;
  transform: translateX(-22px);
`;

export const ImageWrapperSt = styled.div`
  width: 178px;
  margin-top: 16px;

  > img {
    width: 216px;
  }
`;

export const CtasWrapperSt = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-top: 16px;
  font-size: 16px;
`;
